var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2740_26865)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83302 1.17853C9.19924 1.17853 8.59142 1.46073 8.14328 1.96306C7.69513 2.46539 7.44336 3.1467 7.44336 3.8571V10.9999C7.44336 11.7103 7.69513 12.3917 8.14328 12.894C8.59142 13.3963 9.19924 13.6785 9.83302 13.6785C10.4668 13.6785 11.0746 13.3963 11.5228 12.894C11.9709 12.3917 12.2227 11.7103 12.2227 10.9999V3.8571C12.2227 3.1467 11.9709 2.46539 11.5228 1.96306C11.0746 1.46073 10.4668 1.17853 9.83302 1.17853V1.17853Z",
    stroke: "#11131F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4076 9.21423V10.9999C15.4076 12.6575 14.8202 14.2473 13.7745 15.4194C12.7288 16.5915 11.3106 17.2499 9.83174 17.2499C8.35293 17.2499 6.93468 16.5915 5.889 15.4194C4.84332 14.2473 4.25586 12.6575 4.25586 10.9999V9.21423",
    stroke: "#11131F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.83203 17.2499V20.8214",
    stroke: "#11131F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.64648 20.8214H13.0189",
    stroke: "#11131F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2740_26865"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1173,
    height: 21.4286,
    fill: "white",
    transform: "translate(0.273438 0.285645)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.374d1523f15ca6a6c9d60bdff107e547.svg";
export { ForwardRef as ReactComponent };